export type ChatSearchMessage = {
  id: number;
  text: string;
  files: { file_name: string }[];
};

export type ChatSearchFile = {
  file_name: string;
};

export function normalizeChatThreadSearchQuery(query: string): string {
  return query.trim().toLowerCase();
}

export function chatMessageMatchesThreadSearch(message: ChatSearchMessage, query: string): boolean {
  if (!query) {
    return true;
  }
  if ((message.text ?? "").toLowerCase().includes(query)) {
    return true;
  }
  return (message.files ?? []).some((f) => (f.file_name ?? "").toLowerCase().includes(query));
}

export function chatFileMatchesThreadSearch(file: ChatSearchFile, query: string): boolean {
  if (!query) {
    return true;
  }
  return (file.file_name ?? "").toLowerCase().includes(query);
}
